if (location.pathname.startsWith('/ccs')) {
  import('./ccs/entry');
} else if (location.pathname.startsWith('/portal')) {
  import('./portal/entry');
} else {
  // FIXME: When portal comes around we need to make this cleaner.
  location.pathname = '/ccs';
}
